import React from 'react';

import type { ExtensionParams } from '@atlaskit/editor-common/extensions';
import {
	ExtensionMode,
	HubExtensionsWrapper,
	type ProductDependenciesProviderProps,
	useProductDependencies,
} from '@atlassian/company-hub-common';

import type { LinksMenuParameters } from '../../../types';
import { extensionHasParams, LinksMenuContent } from '../links-menu-content';

export type LinksMenuInnerProps = {
	contentId: string;
	extensionNode?: ExtensionParams<LinksMenuParameters>;
	isInEditor?: boolean;
};

type LinksMenuProps = LinksMenuInnerProps & {
	mode: ExtensionMode;
	propsProvider: React.ComponentType<ProductDependenciesProviderProps>;
};

export const LinksMenuInner = ({
	extensionNode,
	contentId,
	isInEditor,
}: LinksMenuInnerProps): React.JSX.Element | null => {
	const { isCompanyHub } = useProductDependencies();

	if (!extensionNode || !extensionHasParams(extensionNode) || !isCompanyHub) {
		return null;
	}

	return (
		<HubExtensionsWrapper<LinksMenuParameters>
			extensionNode={extensionNode}
			contentId={contentId}
			mode={ExtensionMode.RENDERER}
			showNoDataState={!extensionHasParams(extensionNode)}
			packageName="links-menu-extension"
		>
			<LinksMenuContent
				contentId={contentId}
				extensionNode={extensionNode}
				isInEditor={isInEditor}
			/>
		</HubExtensionsWrapper>
	);
};

export const LinksMenu = ({
	propsProvider: PropsProvider,
	...props
}: LinksMenuProps): React.JSX.Element => (
	<PropsProvider {...props}>
		<LinksMenuInner {...props} />
	</PropsProvider>
);
